const Strings = {
  MY_INFORMATION: {
    SE: 'Mina uppgifter',
    EN: 'My information'
  },
  DELETE_ACCOUNT: {
    SE: 'Radera konto',
    EN: 'Delete Account'
  },
  DELETE_ACCOUNT_DESCRIPTION: {
    SE: 'Radera ditt konto permanent. Denna åtgärd kan inte ångras.',
    EN: 'Permanently delete your account. This action cannot be undone.'
  },
  APARTMENT: {
    SE: 'Lägenhetsnummer',
    EN: 'Apartment number'
  },
  EMAIL: {
    SE: 'Email',
    EN: 'Email'
  },
  PASSWORD: {
    SE: 'Lösenord',
    EN: 'Password'
  },
  ASSOCIATION: {
    SE: 'Förening',
    EN: 'Association'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/containers/SettingsTable/strings.js